module.exports = __webpack_public_path__ + "media/gp_turbo_select_1.345a3c18.mp3";